<template>
    <div class="goods">
        <v-head :title="title"></v-head>
        <div class="content">
            <div class="order-list">
                <div class="warmTips" v-if="orderList.content && !orderList.content.length">
                    <img src="../../assets/images/404.png" />
                    <span>没有找到相应内容哦</span>
                </div>
                <template v-for="item in orderList.content">
                    <mail-Order :item="item" :key="item.title">
                    </mail-Order>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { Field, Button, Toast, CellGroup } from "vant";
    import mailOrder from "@/components/mail.vue"
    import vHead from "../../components/Subhead.vue";
    import { getOrderInfo } from "@/api/dictionary";
    import { setSessionStore, getSessionStore } from "@/utils/sessionStorage.js"
    export default {
        data() {
            return {
                const_invoice_status_no: 1,
                const_invoice_status_apply: 2,
                const_invoice_status_already: 3,
                const_order_status_paid: 5,
                title: "收件管理",
                loading: true,
                page: 1,
                filterBox: {
                    invoiceStatus: 3,
                    orderType: 1
                },
                orderList: {
                    content: []
                },
                navActive: 3,
            };
        },
        filters: {

        },
        components: {
            vHead,
            mailOrder,
        },
        methods: {
            changActive(val) {
                this.navActive = val;
            },
            getData: function () {
                //   this.loading = true;
                //   this.page=1;

                //   var params=this.filterBox;
                //   if(this.type==1){
                //       params.orderTypeList = [1,3,4,5,6];
                //   }else {
                //       params.orderStatusList = this.const_order_status_paid;
                //   }
                //   params.orderType = 1;
                let token = getSessionStore("access_token");
                let params = this.filterBox;
                params.access_token = token
                getOrderInfo(params, this.page - 1)
                    .then(res => {
                        if (res.success) {
                            this.orderList = res.result;
                        } else {
                            Toast.fail(res.message);
                        }
                    })
                    .catch(() => {
                        Toast.fail("获取数据失败");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },
        computed: {
            type() {
                return this.$route.query && this.$route.query.type;
            }
        },
        watch: {

        },
        mounted() {
            this.getData();
        }

    }
</script>
<style lang="less" scoped>
    .Payment {
        position: absolute;
        z-index: 9999;
        right: 20px;
        top: 21px;
        color: #fff;
    }

    .Order {
        background: #fafafa;
        padding: 15px 0;
        margin-top: 15px;
    }

    .Order p {
        line-height: 24px;
        color: #848484;
    }

    .fontsBox {
        width: 84%;
        margin: 20px auto 0 auto;
        background: #fff6ec;
        padding: 14px;
        font-size: 13px;
        border: #f6d0a2 dashed 1px;
        line-height: 22px;
        color: #ffbe4e;
    }

    .warmTips,
    .orderTip {
        font-size: 16px;
        text-align: center;
        margin-top: 25%;
    }

    /deep/.van-nav-bar__text {
        color: #000;
    }
</style>